type AttrProcessorType = {
  renderHTML:
    | ((attributes: Record<string, unknown>) => Record<string, unknown> | null)
    | null;
  parseHTML: ((element: HTMLElement) => unknown | null) | null;
};

export const toDataAttrs = (attr: string): AttrProcessorType => ({
  parseHTML: element => element.getAttribute('data-' + attr),
  renderHTML: attributes => {
    if (!attributes[attr]) {
      return {};
    }

    return {
      ['data-' + attr]: attributes[attr],
    };
  },
});

